export default "__VITE_ASSET__Bl6lLKIZ__"